import React, { useState } from 'react';
import s from '../styles/ProjectModal.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faSquarePlus } from '@fortawesome/free-solid-svg-icons';
import ExcelUploadModal from './ExcelUploadModal';
import CategoryTree from './CategoryTree';
import CheckPagesModal from './CheckPagesModal';




const ProjectSettingsModal = ({ project, onClose, onSave}) => {
  
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [showCheckPagesModal, setCheckPagesModal] = useState(false);

//   const [formData, setFormData] = useState({ ...project });
const [formData, setFormData] = useState({
    project_name: project.project_name || "",
    yandex_token: project.yandex_token || "",
    avito_client_id: project.avito_client_id || "",
    avito_client_secret: project.avito_client_secret || "",
    google_table: project.google_table || "",
    used_pages: project.used_pages || ""
  });
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setIsSaving(true);
    setError(null);
    setSuccess(false);
    try {
      const response = await fetch(`/api/projects/update_projects/${project.id}`, {
        method: 'PATCH', // или 'PUT', если обновляется вся сущность
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`Ошибка ${response.status}`);
      }
      onSave(formData);
      setSuccess(true);
    //   setTimeout(() => {
    //     onClose();
    //   }, 2000);
    } catch (err) {
      console.error(err);
      setError('Не удалось сохранить изменения.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className={s.modalOverlay}>
      <div className={s.modalContent}>
        <h2 className={s.modal_h2}>Настройки проекта</h2>
        <button onClick={onClose} className={s.close}>
        <FontAwesomeIcon icon={faTimesCircle} />
          </button>
        {error && <div style={{ color: 'red' }}>{error}</div>}
        {success && <div style={{ color: 'green' }}>✅ Сохранено</div>}

        {[
        ['Название проекта', 'project_name', null],
        ['Yandex Token', 'yandex_token', 'https://oauth.yandex.ru/authorize?response_type=token&client_id=7bc0bf0e286d46f59ee384d2bc06fbde'],
        ['Avito Client ID', 'avito_client_id', 'https://www.avito.ru/professionals/api'],
        ['Avito Client Secret', 'avito_client_secret', 'https://www.avito.ru/professionals/api'],
        ['Ссылка на Google Таблицу', 'google_table', null],
        ['Активные листы', 'used_pages', null]
        ].map(([label, name, href]) => (
            <>
            <div className={s.one_input_row}>
            <div className={s.formGroup} key={name}>
            <label className={s.edit_label}>{label}</label>
            <input className={s.edit_input}
              name={name}
              value={formData[name]}
              onChange={handleChange}
            />
            {href ? (
                <a className={s.href_buttons} target="_blank" href={href}>
                    <FontAwesomeIcon icon={faSquarePlus} />
                </a>
                ) : (
                    <></>
                // <div className={s.href_buttons_disabled}>
                //     <FontAwesomeIcon icon={faSquarePlus} />
                // </div>
                )}
          </div>
          
          </div>
            </>
               ))}
        <div>
                  <div className={s.excel_template_buttons_div}>
            <button
              className={s.excelUploadBtn}
              onClick={() => setShowExcelModal(true)}
              disabled={!formData.google_table.startsWith("https://")}
            >
              Загрузить Excel-файл
            </button>
            <button
              className={s.excelUploadBtn}
              onClick={() => setShowTemplateModal(true)}
              disabled={!formData.google_table.startsWith("https://")}
            >
              Добавить шаблон
            </button>

            <button
              className={s.excelUploadBtn}
              onClick={() => setCheckPagesModal(true)}
              disabled={!formData.google_table.startsWith("https://")}
            >
              Проверить Листы
            </button>

          </div>
                      {showExcelModal && (
              <ExcelUploadModal
                googleId={formData.google_table}
                projectId={project.id}
                onClose={() => {setShowExcelModal(false);
                onClose(); }}
              />
            )}


              {showTemplateModal && (
                <CategoryTree
                  projectHref={project.google_table}
                  onClose={() => setShowTemplateModal(false)}
                />
              )}

              {showCheckPagesModal && (
              <CheckPagesModal
                googleId={formData.google_table}
                projectId={formData.used_pages}
                onClose={() => setCheckPagesModal(false)}
              />
            )}

        </div>

        <div className={s.buttonGroup}>
          <button onClick={handleSubmit} disabled={isSaving}>
            {isSaving ? 'Сохранение...' : 'Сохранить'}
          </button>
          <button onClick={onClose} className={s.cancel}>
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectSettingsModal;
